import { useEffect, useState } from 'react';
import { fileService, isStoredObjectKey } from '../services/fileService';

/**
 * Resolves an S3 object key to a short-lived signed URL; passes through http(s)/data/blob unchanged.
 */
export function useResolvedMediaUrl(ref: string | undefined): string | undefined {
  const [url, setUrl] = useState<string | undefined>(() =>
    ref && !isStoredObjectKey(ref) ? ref : undefined
  );

  useEffect(() => {
    if (!ref?.trim()) {
      setUrl(undefined);
      return;
    }
    if (!isStoredObjectKey(ref)) {
      setUrl(ref);
      return;
    }
    let cancelled = false;
    fileService
      .resolveMediaUrl(ref)
      .then((u) => {
        if (!cancelled) setUrl(u);
      })
      .catch(() => {
        if (!cancelled) setUrl(undefined);
      });
    return () => {
      cancelled = true;
    };
  }, [ref]);

  return url;
}
